import React from 'react';
import { Stack, xcss } from '@atlaskit/primitives';

import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { Healthcheck } from '../common/types.tsx';
import HealthcheckTable from './healthcheck-table/index.tsx';
import HealthcheckHeader from './healthcheck-header/index.tsx';

const HealthcheckPageContents = (props: { healthcheck: Healthcheck | null }): React.JSX.Element => {
	return (
		<>
			<JSErrorBoundary
				id="applinks-extra-auth-healthcheck-page"
				teamName="olympus"
				packageName="applinksExtraAuthHealthcheckPage"
			>
				<Stack space="space.200" xcss={styles}>
					<HealthcheckHeader />
					<Stack space="space.800">
						<HealthcheckTable
							title="Prerequisites"
							description="Ensure that the following prerequisites are met before beginning the setup process."
							healthcheckEntries={props.healthcheck?.healthcheckPreconditions ?? null}
						/>
						<HealthcheckTable
							title="OAuth 2.0 Provider Configuration"
							description="Extra Authentication uses an external OAuth 2.0 provider, shared by all products within your organization. The provider must be configured correctly before Application Links can be created."
							healthcheckEntries={props.healthcheck?.healthcheckEntries ?? null}
						/>
						<HealthcheckTable
							title="Applink Status"
							description="Once the authentication provider is configured, you can now create Application Links. All links configured to use Extra Authentication for this site are displayed below."
							healthcheckEntries={props.healthcheck?.healthcheckStatuses ?? null}
						/>
					</Stack>
				</Stack>
			</JSErrorBoundary>
		</>
	);
};

export default HealthcheckPageContents;
const styles = xcss({ padding: 'space.200' });
